import { DELETED_MESSAGE_IDS } from '../../../consts';
export var getThreadMessages = function (state) {
    return function (threadId) {
        var messagesMap = state.domain.chat_message || {};
        var deletedIds = state.domain[DELETED_MESSAGE_IDS] || new Set();
        var notDeletedFilter = function (k) { return deletedIds.has(k) === false; };
        return Object.keys(messagesMap)
            .filter(notDeletedFilter)
            .reduce(function (memo, k) {
            var m = messagesMap[k];
            if (m.thread_id === threadId) {
                memo.push(m);
            }
            return memo;
        }, [])
            .sort(function (a, b) { return new Date(a.created).valueOf() - new Date(b.created).valueOf(); });
    };
};
